/* ============================================================
 * N36 auto-add engine (2026-10-20)
 *
 * Purpose: the ONE place the theme adds a free line to the cart on its
 * own. Every promotion that adds a line is a rule in RULES below
 * (first rules: the Added to Cart one-time 2 lb codes and TASTEOFBEEF;
 * Black Friday tiers go in the same list, not in a second script).
 * The checkout half (codes typed at checkout) is the checkout-code-gift
 * extension in ~/n36/n36-delivery-picker-upsell; it reads the same rules
 * and the same tag. KEEP RULES IN STEP WITH ITS src/autoadd.js.
 *
 * The tag is the wall: every line this engine adds carries
 * _n36_autoadd: <rule id>. A rule only ever changes or removes lines
 * carrying its own id. Untagged lines (anything the customer, the box
 * builder, the Farm Specials band or quick-add put in) are never
 * touched. The leading underscore keeps the tag out of the drawer and
 * checkout (cart-drawer.liquid skips "_" properties).
 *
 * Each pass (always on a FRESH /cart.js read, after 800 ms of cart idle):
 *   1. customer total per rule = final_line_price of the lines the
 *      customer chose, leaving out every _n36_autoadd line, gift
 *      cards, Recharge box lines (_rc_bundle; Shopify discounts can't
 *      see merged box lines, box-builder record 8/3) and the rule's own
 *      variant (Shopify does not count the free unit toward the
 *      minimum, draft-order test 10/20).
 *   2. per group, the FIRST rule in list order whose window, trigger
 *      and threshold are met, and that this cart has not declined or
 *      refused, wins (tiers of one promotion share a group, highest tier
 *      first). Different groups stack.
 *   3. diff against the tagged lines: one /cart/update.js for removals
 *      and quantity resets, one /cart/add.js for adds.
 * No loop: tagged lines never count toward any threshold, so adding or
 * removing one cannot change which rules qualify.
 *
 * free_by 'code': a Shopify code discount makes the line free; the
 * engine only adds while a matching code is on the cart. If, once the
 * line is in and the cart has settled, it is not free (used code, wrong
 * code, items outside the promo collection), the line comes off and the
 * rule is not retried until the customer changes the cart. A customer who
 * removes the free line is not given it again while the same code is
 * on. A free line bumped above its quantity is set back (never billed).
 * While the cart holds a tagged line, the /cart page hides the Apple Pay
 * / Google Pay buttons: wallet sheets skip the checkout half, so a code
 * Shopify drops at checkout could otherwise bill the line.
 *
 * Runs after 'n36cart:updated' (n36-native-cart.js) and on load only
 * when there is something to do: a discount_code cookie that matches a
 * code rule, a cart this browser knows holds a tagged line, a matching
 * code on the event's cart, or a spend-only rule in its window. Inert
 * when the native cart flag is off. Circuit breaker: 6 adds in 60 s stops
 * ADDS for the page (removals always run); /cart reloads capped at 2/min.
 *
 * ES5 only. No modules, no arrows, no let/const, no templates.
 * ============================================================ */
(function () {
  'use strict';

  if (window.N36_NATIVE_CART !== true) return; /* flag off: do nothing at all */
  if (window.__n36Autoadd) return;             /* idempotent */
  window.__n36Autoadd = 1;
  if (!window.fetch || !window.Promise || !window.JSON) return;

  var TAG = '_n36_autoadd';

  /* ---------------------------------------------------------- */
  /* rules (list order = priority)                              */
  /* ---------------------------------------------------------- */
  /* id            line tag value, never reused
     label         plain name (not shown to customers)
     group         rules sharing a group are exclusive; first qualifying wins
     starts, ends  ISO date-times or null
     code_prefix   code rule: a code starting with this must be on the cart;
                   null = spend-only rule
     threshold_cents  customer total needed (see header, step 1)
     variant, quantity  what the rule adds
     free_by       'code' (a Shopify code discount zeroes it) or 'gift'
                   (a $0 gift variant; the checkout gift-guard function
                   must also know the tag before a 'gift' rule goes live)
     skip_if_in_cart  true = a customer line of the same variant satisfies
                   the rule (Shopify frees that unit), so nothing is added */
  var RULES = [
    {
      id: 'atc-2lb',
      label: 'Added to Cart 2 lb gift (one-time codes)',
      group: 'atc-2lb',
      starts: null,
      ends: null,
      code_prefix: 'N36BEEF',
      threshold_cents: 15000, /* $150, Asher via Code Master Oct 20 */
      variant: 49608144191735, /* Ground Beef 2 lb */
      quantity: 1,
      free_by: 'code',
      skip_if_in_cart: true
    },
    {
      /* TASTEOFBEEF (DiscountCodeNode 1731393749239, native Buy X Get Y: 1 item
         from the promo collection, 2 lb free) stays active for emails already
         sent (Asher Oct 20: "will old tase of beef codes work"); retires about
         30 days after the one-time-codes email; same group, never two 2 lb */
      id: 'tob-2lb',
      label: 'TASTEOFBEEF 2 lb gift',
      group: 'atc-2lb',
      starts: null,
      ends: null,
      code_prefix: 'TASTEOFBEEF',
      threshold_cents: 1, /* any 1 qualifying item, no dollar minimum: older emails promised it that way (Asher via Code Master Oct 20) */
      variant: 49608144191735, /* Ground Beef 2 lb */
      quantity: 1,
      free_by: 'code',
      skip_if_in_cart: true
    }
  ];

  /* ---------------------------------------------------------- */
  /* small helpers                                              */
  /* ---------------------------------------------------------- */

  var STATE_KEY = 'n36_autoadd';
  var RELOAD_KEY = 'n36_autoadd_reloads';
  var IDLE_MS = 800;          /* act after the cart has been quiet this long */
  var DECLINE_GRACE_MS = 2500; /* a missing line this soon after our own write is not a decline */
  var MAX_ADDS = 6, WINDOW_MS = 60000;
  var addTimes = [];
  var busy = false, queued = false, addsStopped = false;
  var idleTimer = null, lastWriteAt = 0;
  var memState = null; /* used when localStorage is unavailable */

  function now() { return new Date().getTime(); }

  function inWindow(rule) {
    var t = now();
    if (rule.starts && t < Date.parse(rule.starts)) return false;
    if (rule.ends && t >= Date.parse(rule.ends)) return false;
    return true;
  }

  function upper(s) { return String(s || '').toUpperCase(); }

  function cookieCode() {
    var m = /(?:^|;\s*)discount_code=([^;]*)/.exec(document.cookie || '');
    if (!m) return '';
    try { return upper(decodeURIComponent(m[1])); } catch (e) { return ''; }
  }

  function readRaw() {
    var s = null;
    try { s = JSON.parse(window.localStorage.getItem(STATE_KEY) || 'null'); } catch (e) { s = memState; }
    return s;
  }
  /* per-browser memory, keyed to the cart token so a new cart starts clean */
  function loadState(token) {
    var s = readRaw();
    if (!s || typeof s !== 'object') s = {};
    if (token && s.token !== token) s = { token: token };
    s.added = s.added || {};       /* ruleId -> code (or '*') the line was added under */
    s.declined = s.declined || {}; /* ruleId|code -> customer removed the free line */
    s.refused = s.refused || {};   /* ruleId|code|signature -> Shopify said no */
    return s;
  }
  function saveState(s) {
    memState = s;
    try { window.localStorage.setItem(STATE_KEY, JSON.stringify(s)); } catch (e) {}
  }

  function tagOf(item) {
    var p = item && item.properties;
    return (p && !Array.isArray(p) && p[TAG]) ? String(p[TAG]) : '';
  }
  function isBoxLine(item) {
    var p = item && item.properties;
    return !!(p && !Array.isArray(p) && p._rc_bundle);
  }

  function matchCode(cart, prefix) {
    var list = (cart && cart.discount_codes) || [];
    var pre = upper(prefix);
    for (var i = 0; i < list.length; i++) {
      if (upper(list[i].code).indexOf(pre) === 0) return list[i];
    }
    return null;
  }
  function ruleCode(cart, rule) { return rule.code_prefix ? matchCode(cart, rule.code_prefix) : null; }

  /* list prices (original_line_price), the base the function measures on; the
     customer's own units of the rule's variant count, except the one Shopify
     frees when there is no tagged line (red team 2026-10-20) */
  function customerTotal(cart, rule) {
    var items = cart.items || [];
    var hasTagged = items.some(function (i) { return tagOf(i) === rule.id; });
    var total = items.filter(function (i) {
      return !tagOf(i) && !i.gift_card && !isBoxLine(i);
    }).reduce(function (s, i) { return s + (i.original_line_price || 0); }, 0);
    if (!hasTagged) {
      var own = null;
      items.some(function (i) { if (!tagOf(i) && !isBoxLine(i) && i.variant_id === rule.variant) { own = i; return true; } return false; });
      if (own) total -= (own.original_price || 0) * Math.min(own.quantity || 1, rule.quantity);
    }
    return total;
  }
  /* the customer's part of the cart, so a refusal is retried only after
     the customer changes something */
  function signature(cart) {
    return (cart.items || []).filter(function (i) { return !tagOf(i); })
      .map(function (i) { return i.variant_id + 'x' + i.quantity; }).sort().join(',');
  }

  function post(url, body) {
    /* through window.fetch ON PURPOSE: the native cart wrapper re-renders
       the drawer and fires n36cart:updated after every cart op */
    return window.fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }
  function getCart() {
    return window.fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; });
  }
  function fullCart(c) { return !!(c && Array.isArray(c.items) && Array.isArray(c.discount_codes)); }

  function onCartPage() {
    return /^\/cart\/?$/.test(window.location.pathname) && !!document.querySelector('cart-items:not(cart-drawer-items)');
  }
  /* at most 2 engine reloads of /cart per minute, whatever storage does */
  function mayReload() {
    var t = now(), list = [];
    try { list = JSON.parse(window.sessionStorage.getItem(RELOAD_KEY) || '[]'); } catch (e) { return false; }
    list = list.filter(function (x) { return t - x < WINDOW_MS; });
    if (list.length >= 2) return false;
    list.push(t);
    try { window.sessionStorage.setItem(RELOAD_KEY, JSON.stringify(list)); } catch (e) { return false; }
    return true;
  }

  /* wallet buttons off on /cart while a tagged line is in (see header) */
  function walletGuard(holds) {
    if (!document.getElementById('n36-autoadd-style')) {
      var st = document.createElement('style');
      st.id = 'n36-autoadd-style';
      st.textContent = 'body.n36-autoadd-holds .cart__dynamic-checkout-buttons{display:none !important}';
      (document.head || document.documentElement).appendChild(st);
    }
    if (document.body) document.body.classList.toggle('n36-autoadd-holds', !!holds);
  }

  function addsAllowed() {
    if (addsStopped) return false;
    var t = now();
    addTimes = addTimes.filter(function (x) { return t - x < WINDOW_MS; });
    if (addTimes.length >= MAX_ADDS) {
      addsStopped = true;
      try { console.warn('[n36-autoadd] adds stopped: ' + MAX_ADDS + ' adds in 60 s'); } catch (e) {}
      return false;
    }
    return true;
  }

  /* ---------------------------------------------------------- */
  /* one pass                                                   */
  /* ---------------------------------------------------------- */

  function plan(cart) {
    var st = loadState(cart.token);
    var sig = signature(cart);
    var quiet = now() - lastWriteAt >= DECLINE_GRACE_MS;
    var tagged = {};
    (cart.items || []).forEach(function (i) {
      var t = tagOf(i);
      if (t) (tagged[t] = tagged[t] || []).push(i);
    });

    /* customer removed a free line we added: honor it under that code
       (only judged on a fresh read well after our own last write) */
    RULES.forEach(function (rule) {
      if ((tagged[rule.id] || []).length) return;
      var mark = st.added[rule.id];
      if (!mark) return;
      var c = ruleCode(cart, rule);
      var code = c ? upper(c.code) : '*';
      if (quiet && mark === code) st.declined[rule.id + '|' + code] = true;
      if (quiet) delete st.added[rule.id];
    });

    /* which rule wins each group */
    var winners = {}, taken = {};
    RULES.forEach(function (rule) {
      if (taken[rule.group] || !inWindow(rule)) return;
      var c = ruleCode(cart, rule);
      if (rule.code_prefix && !c) return;
      if (customerTotal(cart, rule) < rule.threshold_cents) return;
      var code = c ? upper(c.code) : '*';
      var mine = (tagged[rule.id] || []).length > 0;
      /* refused for this cart, or declined under this code: step aside so a
         lower rule in the group can win (a line still in is judged below) */
      if (!mine && (st.refused[rule.id + '|' + code + '|' + sig] || st.declined[rule.id + '|' + code])) return;
      if (mine && rule.free_by === 'code' && quiet) {
        /* the line we added is judged by its own discount once the cart has settled:
           no discount on it, whatever the reason (used code, items outside the promo
           collection, a second code), means it comes off (red team 2026-10-20). A
           bumped line (one unit free, one paid) still carries the discount: kept
           and set back to the rule's quantity below. */
        /* Shopify SPLITS a bumped line into a free line and a paid line, both
           tagged, so judge across all of them: no discount on any = refused */
        if (!tagged[rule.id].some(function (i) { return i.final_line_price < i.original_line_price; })) {
          st.refused[rule.id + '|' + code + '|' + sig] = true;
          return;
        }
      }
      taken[rule.group] = true;
      winners[rule.id] = { rule: rule, code: code };
    });

    var updates = {}, adds = [], hasUpdates = false;
    RULES.forEach(function (rule) {
      var lines = tagged[rule.id] || [];
      var win = winners[rule.id];

      if (!win) {
        lines.forEach(function (i) { updates[i.key] = 0; hasUpdates = true; });
        if (lines.length) delete st.added[rule.id]; /* the engine removed it, not the customer */
        return;
      }

      if (lines.length) {
        /* exactly one tagged line at the rule's quantity: the one carrying the
           discount is kept (Shopify splits a bumped line into free + paid);
           extras are dropped, never converted into a paid line nobody chose */
        var keep = null;
        lines.forEach(function (i) { if (!keep && i.final_line_price < i.original_line_price) keep = i; });
        if (!keep) keep = lines[0];
        lines.forEach(function (i) {
          if (i === keep) {
            if (i.quantity !== rule.quantity) { updates[i.key] = rule.quantity; hasUpdates = true; }
          } else {
            updates[i.key] = 0; hasUpdates = true;
          }
        });
        st.added[rule.id] = win.code;
        return;
      }

      /* nothing tagged yet: add, unless the customer already has one */
      if (rule.skip_if_in_cart && (cart.items || []).some(function (i) {
        return !tagOf(i) && !isBoxLine(i) && i.variant_id === rule.variant;
      })) return;
      var props = {}; props[TAG] = rule.id;
      adds.push({ id: rule.variant, quantity: rule.quantity, properties: props, _rule: rule.id, _code: win.code });
    });

    /* inside the grace window nothing was judged: look again once it ends */
    var recheck = !quiet && RULES.some(function (r) { return (tagged[r.id] || []).length || st.added[r.id]; });
    return { st: st, sig: sig, updates: hasUpdates ? updates : null, adds: adds, recheck: recheck };
  }

  function apply(p) {
    var work = Promise.resolve(false);
    if (p.updates) {
      work = work.then(function () {
        lastWriteAt = now();
        return post('/cart/update.js', { updates: p.updates }).then(function (r) { return !!(r && r.ok); });
      });
    }
    if (p.adds.length && addsAllowed()) {
      work = work.then(function (changed) {
        lastWriteAt = now();
        addTimes.push(lastWriteAt);
        var items = p.adds.map(function (a) { return { id: a.id, quantity: a.quantity, properties: a.properties }; });
        return post('/cart/add.js', { items: items }).then(function (r) {
          lastWriteAt = now();
          p.adds.forEach(function (a) {
            if (r && r.ok) p.st.added[a._rule] = a._code;
            else p.st.refused[a._rule + '|' + a._code + '|' + p.sig] = true; /* sold out etc. */
          });
          return changed || !!(r && r.ok);
        });
      });
    }
    return work.then(function (changed) {
      saveState(p.st);
      return changed;
    });
  }

  function run() {
    if (busy) { queued = true; return; }
    busy = true;
    getCart().then(function (cart) {
      if (!fullCart(cart)) return false;
      var p = plan(cart);
      var holds = (cart.items || []).some(function (i) { return !!tagOf(i); });
      walletGuard(holds || p.adds.length > 0);
      if (p.recheck) setTimeout(schedule, DECLINE_GRACE_MS);
      if (!p.updates && !p.adds.length) {
        p.st.holds = holds;
        saveState(p.st);
        return false;
      }
      p.st.holds = true;
      return apply(p);
    })['catch'](function () { return false; }).then(function (changed) {
      busy = false;
      /* the /cart page has no drawer swap for its own list: reload to repaint */
      if (changed && onCartPage() && mayReload()) { window.location.reload(); return; }
      if (queued) { queued = false; schedule(); }
    });
  }

  /* wait for the cart to go quiet, so the drawer has repainted and a tap
     on a stale line index can't land on a line this engine just moved */
  function schedule() {
    if (idleTimer) clearTimeout(idleTimer);
    idleTimer = setTimeout(function () { idleTimer = null; run(); }, IDLE_MS);
  }

  /* ---------------------------------------------------------- */
  /* wiring                                                     */
  /* ---------------------------------------------------------- */

  function worthACheck(cart) {
    var st = readRaw();
    if (st && st.holds) return true;
    var cc = cookieCode();
    return RULES.some(function (rule) {
      if (!inWindow(rule)) return false;
      if (!rule.code_prefix) return true;
      if (cc && cc.indexOf(upper(rule.code_prefix)) === 0) return true;
      return !!(cart && matchCode(cart, rule.code_prefix));
    });
  }

  document.addEventListener('n36cart:updated', function (e) {
    var c = e && e.detail ? e.detail.cart : null;
    if (worthACheck(fullCart(c) ? c : null)) schedule();
  });

  function onLoad() {
    var s = readRaw();
    if (s && s.holds) walletGuard(true); /* no flash of wallet buttons before the first read */
    if (worthACheck(null)) schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onLoad);
  else onLoad();

  /* read-only view for testing: window.N36Autoadd.rules / .state() */
  window.N36Autoadd = {
    rules: RULES,
    state: function () { return readRaw(); }
  };
})();
